var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoOffMobile = function SvgVideoOffMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.587 30.651c.29.479.957.608 1.49.288.532-.32.729-.967.439-1.446L8.602 4.886c-.29-.479-.957-.607-1.49-.288-.532.32-.728.968-.438 1.446l14.913 24.607ZM6.675 9.033l10.722 17.968H7.111C5.393 27.001 4 25.536 4 23.73V12.274c0-1.652 1.163-3.018 2.675-3.24Zm15.214-.032h-8.836L23.687 26.4c.072-.053.142-.11.21-.17a3.337 3.337 0 0 0 1.103-2.5V12.274c0-1.807-1.393-3.273-3.111-3.273Zm4.611 7.232c0-.565.238-1.096.642-1.431l4.846-4.02c.834-.693 2.012-.022 2.012 1.145v12.15c0 1.166-1.178 1.837-2.012 1.145l-4.846-4.02c-.404-.336-.642-.867-.642-1.432v-3.537Z",
    fill: "#fff",
    fillOpacity: 0.85
  })));
};
export default SvgVideoOffMobile;